import FooterLinks from '@/containers/Footer/FooterLinks';
import FooterSocial from '@/containers/Footer/FooterSocial';
import { TypeMegaMenuComponentWithoutUnresolvableLinksResponse } from '@/features/contentful/_generated';
import MainBodyToReact from '@/features/contentful/components/MainBodyToReact';

const AppFooter = ({
    lang = 'en',
    footerData,
}: {
    lang?: string;
    footerData?: TypeMegaMenuComponentWithoutUnresolvableLinksResponse;
}) => {
    return (
        <section className="bgBlue">
            <footer className="container gotham-medium">
                <FooterLinks lang={lang} footerColumns={footerData?.fields?.columns} />
                <FooterSocial
                    socialLinks={footerData?.fields?.socialLinks}
                    id={footerData?.sys?.id ?? ''}
                />
                <div className="copyrights">
                    <MainBodyToReact
                        body={footerData?.fields?.copyrightText}
                        classes={{
                            p: 'tw-text-white !tw-text-[12px] !tw-pb-0 !tw-leading-[24px]',
                        }}
                        id={footerData?.sys?.id ?? ''}
                        fieldId="copyrightText"
                    />
                </div>
            </footer>
        </section>
    );
};

export default AppFooter;
